import type { CSSProperties, ReactNode } from "react"

interface FlexProps {
  children: ReactNode
  justify?: CSSProperties["justifyContent"]
  align?: CSSProperties["alignItems"]
  direction?: CSSProperties["flexDirection"]
  gap?: CSSProperties["gap"]
  wrap?: boolean
  className?: string
}

const Flex = ({
  children,
  justify = "space-between",
  align = "center",
  direction = "row",
  gap,
  wrap = false,
  className,
}: FlexProps) => (
  <div
    className={className}
    style={{
      display: "flex",
      flexDirection: direction,
      justifyContent: justify,
      alignItems: align,
      gap,
      flexWrap: wrap ? "wrap" : undefined,
    }}
  >
    {children}
  </div>
)

export default Flex
